import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { FloatingParticles } from './Decorative';
import { useLanguage } from '../i18n/LanguageContext';
export function ForYouSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 px-6 bg-forest text-cream relative overflow-hidden" data-id="element-290">
      <FloatingParticles count={25} color="bg-sage-light" data-id="element-291" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-292">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16" data-id="element-293">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#1A3626] p-10 md:p-14 rounded-[3rem] border border-gold/20 shadow-xl" data-id="element-294">
            <h3 className="text-3xl md:text-4xl font-serif text-gold-light italic mb-10 text-center" data-id="element-295">
              {t('foryou.title_yes')}
            </h3>

            <ul className="space-y-6" data-id="element-296">
              {t('foryou.yes').map((item: string, index: number) => <li key={index} className="flex items-start gap-4" data-id="element-297">
                  <div className="mt-1 bg-gold/20 p-1 rounded-full flex-shrink-0" data-id="element-298">
                    <Check className="w-5 h-5 text-gold-light" data-id="element-299" />
                  </div>
                  <span className="text-lg text-cream/90 font-light leading-relaxed" data-id="element-300">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#8A9A86]/20 p-10 md:p-14 rounded-[3rem] border border-sage-light/30 shadow-xl flex flex-col" data-id="element-301">
            <h3 className="text-3xl md:text-4xl font-serif text-cream italic mb-10 text-center" data-id="element-302">
              {t('foryou.title_no')}
            </h3>

            <ul className="space-y-6 mb-12 flex-grow" data-id="element-303">
              {t('foryou.no').map((item: string, index: number) => <li key={index} className="flex items-start gap-4" data-id="element-304">
                  <div className="mt-1 bg-cream/20 p-1 rounded-full flex-shrink-0" data-id="element-305">
                    <X className="w-5 h-5 text-cream" data-id="element-306" />
                  </div>
                  <span className="text-lg text-cream/90 font-light leading-relaxed" data-id="element-307">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="p-6 bg-forest-dark/40 rounded-2xl border border-cream/10 mt-auto" data-id="element-308">
              <p className="text-cream/80 font-light italic text-center text-lg" data-id="element-309">
                {t('foryou.disclaimer')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}